import { getAdjustedDirection, getClipParams, getTransformTweenParams, } from '../../../utils/animationsUtils';
import { deg2rad } from '@wix/wow-utils';
const name = 'SlideScroll';
const properties = {
    schema: {},
};
const ease = 'linear';
const paramsMap = {
    top: { dx: 0, dy: -1, idx: 0, clip: 'bottom' },
    right: { dx: 1, dy: 0, idx: 1, clip: 'left' },
    bottom: { dx: 0, dy: 1, idx: 2, clip: 'top' },
    left: { dx: -1, dy: 0, idx: 3, clip: 'right' },
};
const oppositeDirections = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
};
const rangeValues = {
    in: (clipFrom, _clipTo, positionFrom, _positionTo) => [
        {
            fromValues: { clip: clipFrom, position: positionFrom },
            toValues: { clip: '', position: { x: 0, y: 0 } },
        },
    ],
    out: (clipFrom, _clipTo, positionFrom, _positionTo) => [
        {
            fromValues: { clip: '', position: { x: 0, y: 0 } },
            toValues: { clip: clipFrom, position: positionFrom },
        },
    ],
    continuous: (clipFrom, clipTo, positionFrom, positionTo) => [
        {
            fromValues: { clip: clipFrom, position: positionFrom },
            toValues: { clip: '', position: { x: 0, y: 0 } },
        },
        {
            fromValues: { clip: '', position: { x: 0, y: 0 } },
            toValues: { clip: clipTo, position: positionTo },
        },
    ],
};
/**
 * SlideScroll
 */
function animate(kit, elements, _duration, _delay, { direction = 'bottom', range = 'in', ...params } = {}) {
    const sequence = kit.sequence(params);
    elements.forEach((element) => {
        const compRect = kit.engine.getBoundingRect(element);
        const contentRect = kit.engine.getBoundingContentRect(element);
        const elementAngleInDeg = Number(kit.engine.getProperty(element, '--comp-rotate-z') || 0);
        const adjDirection = getAdjustedDirection(paramsMap, direction, elementAngleInDeg);
        const clipFrom = getClipParams(compRect, contentRect, paramsMap[adjDirection].clip);
        const clipTo = getClipParams(compRect, contentRect, paramsMap[oppositeDirections[adjDirection]].clip);
        const positionFrom = getTransformTweenParams(contentRect, paramsMap[adjDirection], deg2rad(elementAngleInDeg), 1);
        const positionTo = { x: -positionFrom.x, y: -positionFrom.y };
        const scenes = rangeValues[range](clipFrom, clipTo, positionFrom, positionTo);
        scenes.forEach(({ fromValues, toValues }) => {
            sequence.add([
                kit.animate('BaseClipPath', elements, 1000, 0, {
                    from: fromValues.clip,
                    to: toValues.clip,
                    ease,
                }),
                kit.animate('BasePosition', elements, 1000, 0, {
                    from: fromValues.position,
                    to: toValues.position,
                    ease,
                }),
            ]);
        });
    });
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=slideScroll.js.map